import React from 'react';
import { painPoints } from '../data/painPoints';
import { Section, SectionHeader } from './Shared';
export function PainPoints() {
  return <Section id="problema" tone="cream" data-id="element-187" data-mp="2lmsrwreu1gmy">
      <SectionHeader title="¿Te pasa cada vez que se acerca Halloween?" data-id="element-188" data-mp="26ypit95htotx" />

      <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-189" data-mp="26wbox3mjuiny">
        {painPoints.map(point => <li key={point.situation} className="flex flex-col rounded-2xl bg-white p-5 shadow-card md:p-6" data-id="element-190" data-mp="2bvfy3u9h4gea">
            <h3 className="text-xl font-bold leading-tight text-brand-violet" data-id="element-191" data-mp="1y044xrayuxzh">{point.situation}</h3>
            <p className="mt-2 text-base leading-relaxed text-brand-ink/80" data-id="element-192" data-mp="21x06lq6jb549">
              <span aria-hidden="true" className="font-bold text-brand-orangeDark" data-id="element-193" data-mp="1o1el3szif3gl">
                →{' '}
              </span>
              {point.consequence}
            </p>
          </li>)}
      </ul>

      <p className="mx-auto mt-10 max-w-2xl text-center font-display text-xl font-bold leading-snug text-brand-violet md:text-2xl" data-id="element-194" data-mp="3iee47w33mfsm">
        Reuní las ideas en un solo lugar y elegí una propuesta para empezar.
      </p>
    </Section>;
}